import React from 'react';
import { NavLink,useHistory } from 'react-router-dom';
import FontAwesomeIcon from '../../Icon';
import { PATHS } from '../../../common/constants'

import './Navigation.scss';
import { clearStorageData } from '../../../helpers/upLoadHelper';
const Navigation = ({ router, onSignOut }) => {
  // let history = useHistory()

 let signOut = async () =>{
  localStorage.removeItem('isAnnotationImageUpload');
    // history.push(PATHS.AUTH_SIGN_OUT)
    clearStorageData()
    onSignOut()
  }
  return (
  <nav className="navigation">
    <ul className="navigation__links">
      
        <li
          className="navigation__link"
          key={0}
        >
          
          <div 
          className="navigation__anchor"
            // activeClassName="navigation__anchor--active"
            onClick={ ()  => window.confirm(`Do you want to sign out ?`) && signOut()}
            > 
            <FontAwesomeIcon
              weight="light"
              glyph={'sign-out'}
            />
            Sign Out</div> 

          
        </li>
     
    </ul>
  </nav>
  )
};

export default Navigation;
